<template>
    <div>
        <noscript>
            <div>
                <img
                    :src="'https://mc.yandex.ru/watch/' + counterId"
                    style="position:absolute; left:-9999px;"
                    alt=""
                />
            </div>
        </noscript>
    </div>
</template>

<script>
export default {
    props: {
        counterId: {
            type: Number,
            required: true
        }
    },
    mounted() {
        this.loadYandexMetrika(this.counterId)
    },
    methods: {
        loadYandexMetrika(id) {
            if (!id) return
            if (window[`ym_${id}`]) return // уже есть

            (function(m,e,t,r,i,k,a){
                m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}
                m[i].l=1*new Date()
                for (let j = 0; j < document.scripts.length; j++) {
                    if (document.scripts[j].src === r) return
                }
                k=e.createElement(t)
                a=e.getElementsByTagName(t)[0]
                k.async=1
                k.src=r
                a.parentNode.insertBefore(k,a)
            })(window, document,"script",`https://mc.yandex.ru/metrika/tag.js?id=${id}`, "ym")

            window.ym(id, "init", {
                webvisor: true,
                clickmap: true,
                ecommerce: "dataLayer",
                accurateTrackBounce: true,
                trackLinks: true
            })
        }
    }
}
</script>
